import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OnlyNumber} from '../only-number.directive';

@NgModule({
  imports: [],
  exports: [OnlyNumber],
  declarations: [OnlyNumber]
})
export class CommonDirectiveModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/common-directive/common-directive.module.ts